export const blue = {
    10: "#E9F3F9",
    20: "#D1EAFA",
    30: "#91CBF3",
    40: "#63B6EE",
    50: "#35A1E9",
    60: "#097AC8",
    70: "#006DB6",
    80: "#004F9F",
    90: "#1C3885",
    100: "#012851",
};
